const getKey = id => `data-clone${id}`;

export const encode = data => {
  return JSON.stringify(data);
};

export const decode = data => {
  if (!data) return undefined;
  return JSON.parse(data);
};

export const setCloneData = (id, data) => {
  return window.localStorage.setItem(getKey(id), encode(data));
};

export const getCloneData = id => {
  const result = decode(window.localStorage.getItem(getKey(id)));
  return result;
};
